import React from "react";
import { Card, CardContent, CardHeader } from "../Card";
import { classNames, doNothing } from "@greeter/util";
import { LazyCoverImage } from "@greeter/matter";

import css from "./MiniGreeterEventButtonCard.module.scss";
import { isNewYearsEve } from "@greeter/date";
import { Log } from "@greeter/log";
import { set, subDays } from "date-fns";

const dateFormatter = new Intl.DateTimeFormat("da-DK", {
  day: "numeric",
  month: "short",
  weekday: "short",
});

export type MiniGreeterEventButtonCardProps = React.PropsWithChildren & {
  coverUrl: string;
  date: Date;
  isActive: boolean;
  id?: string;
  onClick?: () => void;
  className?: string;
};

export const MiniGreeterEventButtonCard: React.FC<
  MiniGreeterEventButtonCardProps
> = ({
  id,
  coverUrl,
  date,
  isActive,
  onClick = doNothing,
  className,
  ...props
}) => {
  const isNewYears = isNewYearsEve(set(date, { hours: 0 }));
  return (
    <div id={id} onClick={onClick} {...props}>
      <Card
        {...classNames(
          css.MiniGreeterEventButtonCard,
          isActive ? css.Active : "",
          className
        )}
      >
        <CardHeader className={css.CardHeader}>
          <LazyCoverImage src={coverUrl} />
        </CardHeader>
        <CardContent className={css.CardContent}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {isNewYears && <div style={{ fontSize: 14 }}>NYTÅR</div>}
            <div>
              {dateFormatter.format(isNewYears ? subDays(date, 1) : date)}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
